import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import { useTokenExpiration } from "hooks/useTokenExpiration";
import { useIsIndividualAccount } from "hooks/useIsIndividualAccount";
import { ROUTES } from "constants/index";
import { Spinner } from "components/ui";

interface CompanyOnlyRouteProps {
  children: React.ReactNode;
}

/** Authenticated route blocked for individual accounts. */
export const CompanyOnlyRoute: React.FC<CompanyOnlyRouteProps> = ({
  children,
}) => {
  useTokenExpiration();
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const {
    isIndividualAccount,
    isResolved: accountTypeResolved,
    isLoading: accountTypeLoading,
  } = useIsIndividualAccount();
  const location = useLocation();

  if (
    authLoading ||
    (isAuthenticated && (!accountTypeResolved || accountTypeLoading))
  ) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  if (isIndividualAccount) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <>{children}</>;
};
